module.exports = __webpack_public_path__ + "images/0965b46e7fde7dd7db44e4aedef82d6a.webp";